import { useContext, useEffect, useRef, useState } from "react";
import QuizQuestion from "./QuizQuestion";
import QuizSkeleton from "./QuizSkeleton";

import { isGuestAccessMode } from "sj-ui-toolkit/src/utils/guest";
import { setScormPassed } from "sj-ui-toolkit/src/utils/rxd";

import { VideoContext } from "../../VideoContext";
import QuizReview from "./QuizReview";

import S from "./_styles.module.scss";

export default function QuizContent() {
  const { quiz, onQuizFinish } = useContext(VideoContext);
  const [answersCount, setAnswersCount] = useState(quiz?.assessment.answersCount);
  const [question, setQuestion] = useState(null);
  const prevResultRef = useRef(quiz?.assessment.result);
  const isQuizComplete = quiz?.assessment.answersCount === quiz?.assessment.questionsCount;

  useEffect(() => {
    setAnswersCount(quiz?.assessment.answersCount);
    setQuestion(quiz?.question);
  }, [quiz]);

  // Call setScormPassed when quiz result changes to "passed"
  useEffect(() => {
    if (!isGuestAccessMode()) return;

    const currentResult = quiz?.assessment.result;
    const previousResult = prevResultRef.current;

    if (previousResult === "in_progress" && currentResult === "passed") {
      setScormPassed({
        score: quiz?.assessment.assessmentScore ?? 0,
        max: 100,
        min: 0,
      });
    }

    prevResultRef.current = currentResult;
  }, [quiz?.assessment.result, quiz?.assessment.assessmentScore]);

  const handleContinue = submissionData => {
    if (submissionData.nextQuestion) {
      setQuestion(submissionData.nextQuestion);
      setAnswersCount(submissionData.answersCount);
    }
    if (
      submissionData.nextQuestion === null &&
      submissionData.answersCount === quiz.assessment.questionsCount
    ) {
      onQuizFinish(submissionData);
    }
  };

  if (isQuizComplete) {
    return (
      <div className={S.quizContainer}>
        <QuizReview quiz={quiz} />
      </div>
    );
  }

  return (
    <div className={S.quizContainer}>
      {question ? (
        <QuizQuestion
          question={question}
          answersCount={answersCount}
          questionsCount={quiz.assessment.questionsCount}
          onContinue={handleContinue}
        />
      ) : (
        <QuizSkeleton />
      )}
    </div>
  );
}
